import { InputBase } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
const StyledInputBase = styled(InputBase) `
  padding: 0 8px;
  &:hover,
  &:focus-within {
    border: solid 1px #ccc;
    border-radius: 4px;
    margin: -1px;
  }
  &:focus-within {
    background: #fff;
  }
  &.MuiInputBase-multiline {
    padding: 8px;
    background: #f4f4f4;
    &:hover,
    &:focus-within {
      background: #fff;
    }
  }
`;
export const ConfigInput = props => {
    return React.createElement(StyledInputBase, Object.assign({}, props));
};
export default ConfigInput;
//# sourceMappingURL=ConfigInput.js.map